import React, { useEffect, useState } from 'react';
import { callApiWithAuthorization } from '../../../../API/CallApi';

function useGetInvoices(organizationId, subscriptionId) {

    const [loading, setLoading] = useState(true);
    const [invoices, setInvoices] = useState([]);
    const [error, setError] = useState("");
    
    useEffect(() => {
        getInvoices();
    }, []);

    async function getInvoices() {
        try {
            const request = await callApiWithAuthorization("/api/v0/organization/"+ organizationId +"/subscription/"+subscriptionId+"/invoices?expand=data.charge");
            const response = await request.json();
            if (response.error) {
                throw new Error(response.error);
            }
            setInvoices(response.invoices);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }

    return { loading, invoices, error };
}

export default useGetInvoices;